module.exports = __webpack_public_path__ + "static/media/golf.9135cc30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/golf.svg
// module id = 380
// module chunks = 7